var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#FFF",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m175.471 392.682-28.979-28.977-75.472-75.474c-11.631-11.633-11.631-30.608 0-42.242l7.859-7.856c11.631-11.633 30.607-11.633 42.24 0l54.352 54.35c11.633 11.633 30.609 11.634 42.242 0l173.166-173.165c11.633-11.634 30.609-11.634 42.242 0l7.857 7.856c11.633 11.633 11.635 30.609 0 42.242l-194.287 194.289-28.979 28.977c-11.632 11.632-30.608 11.632-42.241 0z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.25cb9e5717d7a1871aa17b0258d83461.svg";
export { ForwardRef as ReactComponent };